import Animations from 'animations';

function appendFilterTrackValue(target, key, value) {
  if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = value;
  } else {
    target[key] = `${target[key]},${value}`;
  }
}

/** 神策 query_data：仅从筛选相关 form 读取（展示名见 data-filter-track-label） */
function buildFilterTrackQueryData(forms) {
  const queryData = {};
  for (const form of forms) {
    if (!form) continue;

    const sortSelect = form.querySelector('select[name="sort_by"]');
    if (sortSelect?.value) {
      queryData.sort_by = sortSelect.value;
    }

    form
      .querySelectorAll('input.collection-sidebar__filter__input[type="checkbox"]:checked')
      .forEach(input => {
        if (!input.name) return;
        const display = input.dataset.filterTrackLabel || '';
        if (!display) return;
        appendFilterTrackValue(queryData, input.name.replace(/\./g, '_'), display);
      });

    form.querySelectorAll('input.collection-sidebar__filter-price__input').forEach(input => {
      if (!input.name || input.value === '') return;
      queryData[input.name.replace(/\./g, '_')] = input.value;
    });
  }
  return queryData;
}

class DynamicProductSearch extends HTMLElement {
  #e;
  #t;
  #r;
  constructor() {
    super(),
      (this.#e = this.#n.bind(this)),
      (this.#t = this.#s.bind(this)),
      (this.#r = this.#i.bind(this));
  }
  connectedCallback() {
    (this.abortController = null),
      (this.listeners = []),
      (this.section = this.closest('.section')),
      this.updateLoading(),
      this.#o(),
      window.addEventListener('popstate', this.#r);
  }
  disconnectedCallback() {
    this.#l(), window.removeEventListener('popstate', this.#r);
  }
  renderError(e = window.theme.localize('ERROR_PRODUCTS')) {
    this.previousElementSibling &&
      this.previousElementSibling.classList.contains('error') &&
      this.previousElementSibling.remove();
    const t = document.createElement('div');
    t.classList.add('error'), (t.innerHTML = e), this.section.prepend(t);
  }
  renderCollection(e) {
    const {
      query: t,
      updateURL: r,
      scrollUp: n,
    } = { query: '', updateURL: !0, scrollUp: !1, ...e },
      s = document.activeElement && document.activeElement.getAttribute('id'),
      i = `.section--${this.dataset.section}`;
    (this.abortController = new AbortController()),
      this.updateLoading(!0),
      fetch(`${this.dataset.url}?${t}&section_id=${this.dataset.section}`, {
        signal: this.abortController.signal,
      })
        .then(e => {
          if (e.ok) return e.text();
          throw new Error(window.theme.localize('ERROR_PRODUCTS'));
        })
        .then(e => {
          this.dispatchEvent(new CustomEvent('on:dynamic-product-search:loading'));
          let o = 0;
          const l = this.querySelector('predictive-search');
          l && l.close();
          const a = this.querySelector('.modal--filters:not([aria-hidden="true"])');
          if (a) {
            const e = a.querySelector('.collection-sidebar__wrapper');
            e && (o = e.scrollTop);
          }
          const c = new DOMParser().parseFromString(e, 'text/html'),
            d = document.querySelector(i),
            h = c.querySelector(i);
          if (h && d) {
            this.#l();
            const e = d.querySelector('.js-main-content'),
              t = h.querySelector('.js-main-content');
            if (e.children.length > 0 && t.children.length > 0) {
              const t = d.querySelector('.js-results-total'),
                r = d.querySelector('.js-sort-form'),
                n = d.querySelector('.js-active-filters'),
                s = d.querySelector('.js-filters'),
                i = d.querySelector('.js-actions'),
                o = d.querySelector('.js-results-container'),
                l = d.querySelector('.js-results'),
                a = d.querySelector('.js-pagination'),
                c = h.querySelector('.js-results-total'),
                u = h.querySelector('.js-sort-form'),
                m = h.querySelector('.js-active-filters'),
                p = h.querySelector('.js-filters'),
                S = h.querySelector('.js-actions'),
                y = h.querySelector('.js-results-container'),
                L = h.querySelector('.js-results'),
                f = h.querySelector('.js-pagination');
              (t.innerHTML = c.innerHTML),
                o && y
                  ? (r && (r.innerHTML = u.innerHTML),
                    (n.innerHTML = m.innerHTML),
                    p && (s.innerHTML = p.innerHTML),
                    S && (i.innerHTML = S.innerHTML),
                    (l.innerHTML = L.innerHTML))
                  : o
                    ? o.remove()
                    : y
                      ? e.appendChild(y) : '',
                a && f
                  ? (a.innerHTML = f.innerHTML)
                  : a
                    ? a.remove()
                    : f && d.querySelector('.js-main-content').appendChild(f);
            } else {
              if (d.querySelector('.js-section-title') && h.querySelector('.js-section-title')) {
                d.querySelector('.js-section-title').innerHTML =
                  h.querySelector('.js-section-title').innerHTML;
              }
              if (d.querySelector('.js-main-content') && h.querySelector('.js-main-content')) {
                d.querySelector('.js-main-content').innerHTML =
                  h.querySelector('.js-main-content').innerHTML;
              }
            }

            this.#o();
          }
          if ((Animations.setup(document.querySelector(i)), a)) {
            const e = a.querySelector('.collection-sidebar__wrapper');
            e && 0 !== o && (e.scrollTop = o);
          }
          n && this.scrollUp();
          const u = document.querySelector(`${i} dynamic-product-search`).dataset.pageTitle;
          r && this.updateURL(t, u),
            (document.title = u),
            this.updateLoading(!1),
            'true' === this.dataset.quickShopDynamicCheckout &&
            window.Shopify &&
            window.Shopify.PaymentButton &&
            window.Shopify.PaymentButton.init();
          const m = document.getElementById(s);
          m && m.focus(), this.dispatchEvent(new CustomEvent('on:dynamic-product-search:loaded'));
        })
        .catch(async e => {
          if (e.name && 'AbortError' === e.name) return;
          this.updateLoading(!1), this.renderError(e);
          const t = this.querySelector('.modal--filters:not([aria-hidden="true"])');
          t && (await t.close()),
            this.scrollUp(),
            this.dispatchEvent(new CustomEvent('on:dynamic-product-search:failed'));
        });
  }
  scrollUp() {
    const { top: e } = this.section.getBoundingClientRect();
    window.scrollBy({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'instant'
        : 'smooth',
      top: e,
    });
  }
  updateLoading(e = !1) {
    (this.loading = e),
      e ? this.section.classList.add('is-loading') : this.section.classList.remove('is-loading');
  }
  updateURL(e, t = '') {
    'false' !== this.dataset.updateUrl &&
      window.history.pushState({}, t, `${this.dataset.url}${e ? `?${e}` : ''}`);
  }
  #i() {
    const e = window.location.search.slice(1);
    this.renderCollection({ updateURL: !1, query: e });
  }
  #n(e, t = !1) {
    if ((e.preventDefault(), !e.target.getAttribute('href') && !e.target.dataset.url)) return;
    const r = e.target.getAttribute('href') || e.target.dataset.url,
      n = r.split('?').length > 0 ? r.split('?')[1] : '';
    this.renderCollection({ query: n, scrollUp: t });
  }
  #s(e) {
    this.#n(e, !0);
  }
  #a() {
    this.querySelectorAll('.js-filter-trigger').forEach(e => {
      e.addEventListener('click', this.#e),
        this.listeners.push({ element: e, event: 'click', handler: this.#e });
    });
  }
  #c() {
    this.querySelectorAll('.pagination a').forEach(e => {
      e.addEventListener('click', this.#t),
        this.listeners.push({ element: e, event: 'click', handler: this.#t });
    });
  }
  #o() {
    (this.forms = [
      this.querySelector('.js-search-form'),
      this.querySelector('.js-sort-form'),
      this.querySelector('.js-filters-form'),
    ].filter(e => e)),
      this.querySelector('.js-search-form') &&
      this.querySelector('.js-filters-form') &&
      this.querySelector('.js-filters-form input[name="q"]') &&
      this.querySelector('.js-filters-form input[name="q"]').remove(),
      this.forms.forEach(e => {
        'true' === e.dataset.submitOnChange &&
          e.addEventListener('change', () => {
            e.requestSubmit();
          }),
          e.addEventListener('submit', e => {
            e.preventDefault(), this.abortController && this.abortController.abort();
            let t = '';
            if (e.target.classList.contains('js-search-form')) {
              const e = ['type', 'q', 'sort_by'];
              t = this.forms.reduce((t, r) => {
                const n = new FormData(r);
                for (const [t] of n.entries()) e.includes(t) || n.delete(t);
                const s = new URLSearchParams(n).toString();
                return `${t}${s ? `${t ? '&' : ''}${s}` : ''}`;
              }, '');
            } else
              t = this.forms.reduce((e, t) => {
                const r = new FormData(t),
                  n = new URLSearchParams(r).toString();
                return `${e}${n ? `${e ? '&' : ''}${n}` : ''}`;
              }, '');
              //修改筛选条件时，上传神策
              if (!e.target.classList.contains('js-search-form')) {
                const trackPayload = {};
                for (const form of this.forms) {
                  const qInput = form?.querySelector('input[name="q"]');
                  if (qInput?.value) {
                    trackPayload.search_keyword = qInput.value;
                  }
                }
                const collectionHandleInput = this.querySelector('#collection_handle');
                if (collectionHandleInput?.value) {
                  trackPayload.collection_handle = collectionHandleInput.value;
                }
                const queryData = buildFilterTrackQueryData(this.forms);
                if (Object.keys(queryData).length > 0) {
                  trackPayload.query_data = JSON.stringify(queryData);
                }
                console.log('trackPayload', trackPayload);
                // window.sensors && sensors.track('filter_detail_edit', trackPayload);
              }
            this.renderCollection({ query: t });
          });
      }),
      this.querySelectorAll('.js-filter-apply').forEach(button => {
        const handler = event => {
          event.preventDefault();
          const form = this.querySelector('.js-filters-form');
          form && form.requestSubmit();
        };
        button.addEventListener('click', handler);
        this.listeners.push({ element: button, event: 'click', handler });
      }),
      this.#a(),
      this.#c();
  }
  #l() {
    this.listeners.forEach(({ element: e, event: t, handler: r }) => {
      e.removeEventListener(t, r);
    });
  }
}
customElements.define('dynamic-product-search', DynamicProductSearch);
//# sourceMappingURL=dynamic-product-search.js.map
